import { modulesService } from '@/services/modules.service';

const initialState = () => ({
  modulesAccess: [],
  tenantModules: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  async getTenantModules({ state, commit }) {
    // tenant modules already loaded, no need to reload
    if (state.status.resolved) {
      return;
    }
    commit('GET_TENANT_MODULES');

    return Promise.all([modulesService.getModules(), modulesService.getTenantModules()])
      .then(([modules, tenantModules]) => {
        commit('GET_TENANT_MODULES_SUCCESS', { modules, tenantModules });
      })
      .catch((error) => {
        commit('GET_TENANT_MODULES_ERROR', error);
      });
  },

  setTenantModule({ commit }, { moduleId, tenantId, hasAccess }) {
    commit('SET_TENANT_MODULE');

    return modulesService
      .setTenantModule({ moduleId, tenantId, hasAccess })
      .then((updatedModule) => {
        commit('SET_TENANT_MODULE_SUCCESS', { updatedModule });
      })
      .catch((error) => {
        commit('SET_TENANT_MODULE_ERROR', error);
        throw error;
      });
  },
};

const mutations = {
  GET_TENANT_MODULES(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  GET_TENANT_MODULES_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
  GET_TENANT_MODULES_SUCCESS(state, { modules, tenantModules }) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.tenantModules = tenantModules;
    state.modulesAccess = modules.map((t1) => ({
      ...t1,
      hasAccess: tenantModules.find((t2) => t2.moduleId === t1.id)
        ? tenantModules.find((t2) => t2.moduleId === t1.id).hasAccess
        : false,
    }));
  },
  SET_TENANT_MODULE(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SET_TENANT_MODULE_SUCCESS(state, { updatedModule }) {
    const moduleIndex = state.modulesAccess.findIndex((module) => module.id === updatedModule.moduleId);
    if (moduleIndex !== -1) {
      state.modulesAccess.splice(moduleIndex, 1, {
        ...state.modulesAccess[moduleIndex],
        hasAccess: updatedModule.hasAccess,
      });
      state.tenantModules.splice(moduleIndex, 1, {
        ...state.tenantModules[moduleIndex],
        hasAccess: updatedModule.hasAccess,
      });
    }
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
  },
  SET_TENANT_MODULE_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: false,
      rejected: true,
      error: error,
    };
  },
};

const getters = {
  modulesAccess: (state) => state.modulesAccess,
  tenantModules: (state) =>
    state.tenantModules.filter((module) => module.hasAccess == true).map((module) => module.moduleId),

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const tenantModules = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
